module.exports = __webpack_public_path__ + "img/tk.42665015.svg";